export default "__VITE_ASSET__BwB3_Lho__"